import { EditorState, AtomicBlockUtils } from 'draft-js';
import EditorUtils from '../../../draft-js-plugins-utils/src';

export default (editorState, src) => {
  const entityKey = EditorUtils.getCurrentEntityKey(editorState);
  const contentState = editorState.getCurrentContent();
  const newContentState = contentState.mergeEntityData(entityKey, { src });
  const newEditorState = EditorState.push(editorState, newContentState, 'apply-entity');

  const selection = editorState.getSelection();
  const anchorKey = selection.getAnchorKey();
  const anchorBlock = contentState.getBlockForKey(anchorKey);

  return EditorState.forceSelection(
    newEditorState,
    selection.merge({
      anchorKey: anchorKey,
      focusKey: anchorKey,
      anchorOffset: anchorBlock.getText().length,
      focusOffset: anchorBlock.getText().length,
    })
  );
};
